import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {},
}));

const Header = (props) => {
  const { children, className, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Typography component="h1" variant="h3">
        {children}
      </Typography>
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
};

export default Header;
